// import React, { useEffect, useState } from "react";
// import "./IndexPageLayout.css";

// import useAuthStore from "../../Zustand/Store/useAuthStore";
// import {
//   Link,
//   Navigate,
//   useLocation,
//   useNavigate,
//   useParams,
// } from "react-router-dom";
// import Footer from "../../Components/Footer/Footer";
// import PersonIcon from "@mui/icons-material/Person";
// import TuneIcon from "@mui/icons-material/Tune";

// import {
//   Box,
//   CssBaseline,
//   Drawer,
//   AppBar,
//   Toolbar,
//   Typography,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   IconButton,
//   useTheme,
//   createTheme,
//   ThemeProvider,
//   MenuItem,
//   Menu,
//   Tooltip,
//   Avatar,
//   Badge,
//   Popover,
// } from "@mui/material";

// import {
//   Mail as MailIcon,
//   Notifications as NotificationsIcon,
//   Brightness4 as Brightness4Icon,
//   Brightness7 as Brightness7Icon,
//   Menu as MenuIcon,
//   Logout as LogoutIcon,
//   Lock as LockIcon,
//   Edit as EditIcon,
//   Dashboard as DashboardIcon,
//   CorporateFare as CorporateFareIcon,
//   Business as BusinessIcon,
//   AddLocationAlt as AddLocationAltIcon,
//   Assignment as AssignmentIcon,
//   Settings as SettingsIcon,
//   Engineering as EngineeringIcon,
//   Store as StoreIcon,
//   Segment as SegmentIcon,
//   AppRegistration as AppRegistrationIcon,
//   Apartment as ApartmentIcon,
//   FormatAlignJustify as FormatAlignJustifyIcon,
//   Autorenew as AutorenewIcon,
//   ExitToApp as ExitToAppIcon,
//   VerifiedUser as VerifiedUserIcon,
//   LocalPolice as LocalPoliceIcon,
//   AccountCircleOutlined,
//   PeopleAltOutlined,
// } from "@mui/icons-material";

// import Swal from "sweetalert2";
// import axios from "axios";
// import { MAIN_URL } from "../../Configurations/Urls";
// import ExpandedSideOption from "./ExpandedSideOption";
// import ExpandTopBarDropOption from "./ExpandTopBarDropOption";
// import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
// import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
// import ErrorIcon from "@mui/icons-material/Error";
// import GroupIcon from "@mui/icons-material/Group";

// export default function RouteProtector({ children }) {

//   const [sidebarVisible, setSidebarVisible] = useState(true);
//       let [showSidebar , SetshowSidebar] = useState(true);

//   const [anchorElTune, setAnchorElTune] = useState(null);

//   const handleOpenTuneMenu = (event) => {
//     setAnchorElTune(event.currentTarget);
//   };

//   const handleCloseTuneMenu = () => {
//     setAnchorElTune(null);
//   };

//   const handleSelectOption = (option) => {
//     console.log("Selected:", option);
//     // Example: navigate based on selected option
//     if (option === "PROJECTIFY") navigate("/");
//     else if (option === "Project Management") navigate("/");

//     handleCloseTuneMenu();
//   };

//   const [darkMode, setDarkMode] = useState(false);
//   const [collapsed, setCollapsed] = useState(false);
//   const [drawerWidth, setDrawerWidth] = useState(290);
//   const [isResizing, setIsResizing] = useState(false);

//   const theme = React.useMemo(
//     () =>
//       createTheme({
//         palette: {
//           mode: darkMode ? "dark" : "light",
//         },
//         components: {
//           MuiOutlinedInput: {
//             styleOverrides: {
//               input: {
//                 backgroundColor: darkMode ? "#1e1e1e" : "#ffffff", // ✅ dynamic bg color
//                 "&:-webkit-autofill": {
//                   WebkitBoxShadow: `0 0 0 1000px ${darkMode ? "#1e1e1e" : "#ffffff"} inset`,
//                   WebkitTextFillColor: darkMode ? "#fff" : "#000",
//                 },
//                 "&:focus": {
//                   backgroundColor: darkMode ? "#1e1e1e" : "#ffffff",
//                 },
//               },
//             },
//           },
//         },
//       }),
//     [darkMode]
//   );

//   const navigate = useNavigate();
//   const location = useLocation();

//   const [anchorElUser, setAnchorElUser] = useState(null);

//   const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
//   const handleCloseUserMenu = () => setAnchorElUser(null);

//   useEffect(() => {
//     const handleMouseMove = (e) => {
//       if (isResizing) {
//         const newWidth = Math.min(Math.max(e.clientX, 75), 400);
//         setDrawerWidth(newWidth);
//       }
//     };

//     const handleMouseUp = () => {
//       if (isResizing) setIsResizing(false);
//     };

//     document.addEventListener("mousemove", handleMouseMove);
//     document.addEventListener("mouseup", handleMouseUp);

//     return () => {
//       document.removeEventListener("mousemove", handleMouseMove);
//       document.removeEventListener("mouseup", handleMouseUp);
//     };
//   }, [isResizing]);

//   const { logout, userData, setAccess, login } = useAuthStore();
//   const access = userData?.role || "Admin";

//   const handleLogout = () => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You want to logout?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, logout",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           const token = localStorage.getItem("token");

//           await axios.get(`${MAIN_URL}/api/auth/logout`, {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           });

//           logout();
//           localStorage.removeItem("token");

//           Swal.fire("Logged out!", "You have been logged out.", "success");
//           navigate("/login");
//         } catch (error) {
//           console.error("Logout failed:", error);
//           Swal.fire("Error", "Logout failed. Please try again.", "error");
//         }
//       }
//     });
//   };

//   const { isLoggedIn } = useAuthStore();
//   let [OpenTCode, setOpenTCode] = useState(false);

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.ctrlKey && e.key === "/") {
//         setOpenTCode(true);
//       }
//     };
//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, []);

//   useEffect(() => {
//     const currentPath = location.pathname;
//     localStorage.setItem("lastVisitedRoute", currentPath);
//   }, [location]);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const lastVisitedRoute = localStorage.getItem("lastVisitedRoute");

//     if (!token) {
//       navigate("/login");
//       return;
//     }

//     axios
//       .get(`${MAIN_URL}/api/auth/token-login`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       })
//       .then((response) => {
//         const { user } = response.data;

//         setAccess(user?.role?.system_role_name);
//         login(user);

//         let dd = user.organization.find(
//           (item) =>
//             item.organization_id ==
//             user.user_active_organization.organization_id
//         );

//         let mm = {
//           ...user,
//           organization: dd,
//         };
//         login(mm);

//         navigate(lastVisitedRoute);
//       })

//       .catch((error) => {
//         navigate("/login");
//       });
//   }, []);

//   let sidebarOptions = [
//     { kind: "header", title: "Features" },
//     {
//       heading: "Dashboard",
//       route: "/",
//       title: "Dashboard",
//       icon: <DashboardIcon />,
//     },
//     { kind: "divider" },
//     {
//       heading: "Organization",
//       title: "Organization",
//       icon: <SettingsIcon />,
//       route: "/organization/switcher",
//     },
//     {
//       heading: "Trainings",
//       title: "Trainings",
//       icon: <SettingsIcon />,
//       children: [
//         {
//           route: "/training-programs",
//           title: "Training Programs",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/training-programs-categories",
//           title: "Training Program Categories",
//           icon: <SettingsIcon />,
//         },
//       ],
//     },
//     {
//       heading: "Students",
//       title: "Students",
//       icon: <SettingsIcon />,
//       children: [
//         {
//           route: "/students",
//           title: "Students",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/students-fees",
//           title: "Student Fees",
//           icon: <SettingsIcon />,
//         },
//       ],
//     },
//     {
//       heading: "Leads",
//       title: "Leads",
//       icon: <SettingsIcon />,
//       children: [
//         {
//           route: "/leads",
//           title: "Leads",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/lead-stages",
//           title: "Lead Stages",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/lead-sources",
//           title: "Lead Sources",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/lead-activities",
//           title: "Lead Activities",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/lead-contact-timings",
//           title: "Lead Contact Timings",
//           icon: <SettingsIcon />,
//         },
//       ],
//     },
//     {
//       heading: "Assesments",
//       title: "Assesments",
//       icon: <SettingsIcon />,
//       children: [
//         {
//           route: "/assesments",
//           title: "Assesments",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/assesment-results",
//           title: "Assesment Results",
//           icon: <SettingsIcon />,
//         },
//       ],
//     },
//     {
//       heading: "Batches",
//       title: "Batches",
//       icon: <SettingsIcon />,
//       children: [
//         {
//           route: "/batches",
//           title: "Batches",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/batch-classes",
//           title: "Batch Classes",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/batch-students",
//           title: "Batch Students",
//           icon: <SettingsIcon />,
//         },
//       ],
//     },
//     {
//       heading: "Others",
//       title: "Others",
//       icon: <SettingsIcon />,
//       children: [
//         {
//           route: "/recruitment-agencies",
//           title: "Recruitment Agencies",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/companies",
//           title: "Companies",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/admissions",
//           title: "Admissions",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/fee-installments",
//           title: "Fee Installments",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/classes-attendance",
//           title: "Classes Attendance",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/certificates",
//           title: "Certificates",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/placement-referrals",
//           title: "Placement Referrals",
//           icon: <SettingsIcon />,
//         },
//         {
//           route: "/demo-sessions",
//           title: "Demo Sessions",
//           icon: <SettingsIcon />,
//         },
//       ],
//     },

//     {
//       heading: "Logout",
//       route: "/logout",
//       title: "Logout",
//       icon: <LogoutIcon />,
//     },
//   ];

//   const currentPath = location.pathname;

//   // 🔐 Route-based Access Control

//   // Protect Employees Page from Admins
//   if (access === "Admin" && currentPath === "/sidebar-option-page-1") {
//     return <Navigate to="/" replace />;
//   }

//   // Protect Admin-only page from Users
//   if (access === "User" && currentPath === "/Admin-only-route") {
//     return <Navigate to="/" replace />;
//   }

//   console.log("axcess", access);
//   console.log("userdata", userData);

//   return (
//     <ThemeProvider theme={theme}>
//       <Box sx={{ display: "flex", height: "100vh" }}>
//         <CssBaseline />
//         <AppBar position="fixed" sx={{ zIndex: 1201 }}>
//           <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
//             <Box sx={{ display: "flex", alignItems: "center" }}>
//               {showSidebar && (
//                 <IconButton
//                   color="inherit"
//                   onClick={() => setSidebarVisible(!sidebarVisible)}
//                   edge="start"
//                 >
//                   <MenuIcon />
//                 </IconButton>
//               )}
//               <Typography variant="h6" noWrap sx={{ ml: 1 }}>
//                 EMS
//               </Typography>
//             </Box>

//             <Box sx={{ flexGrow: 1, marginLeft: "220px", textAlign: "left" }}>
//       <Typography
//         variant="h6"
//         sx={{
//           textTransform: "capitalize",
//           cursor: "pointer",
          
//         }}
//         noWrap
//         onClick={() => navigate("/organization/switcher")}
//       >
//         {userData?.organization?.organization_name}
//       </Typography>
//     </Box>
//             <Box
//               sx={{
//                 flexGrow: 0,
//                 gap: 1,
//                 display: "flex",
//                 alignItems: "center",
//               }}
//             >
//               <Typography
//                 variant="h6"
//                 sx={{ textTransform: "capitalize", ml: 1 }}
//                 noWrap
//               >
//                 {userData?.full_name}
//               </Typography>
//               <IconButton
//                 color="inherit"
//                 onClick={() => setDarkMode(!darkMode)}
//               >
//                 {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
//               </IconButton>
//               <Tooltip title="Open settings">
//                 <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
//                   <Avatar>
//                     <PersonIcon />
//                   </Avatar>
//                 </IconButton>
//               </Tooltip>

//               <Popover
//                 anchorEl={anchorElUser}
//                 open={Boolean(anchorElUser)}
//                 onClose={handleCloseUserMenu}
//                 anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//                 transformOrigin={{ vertical: "top", horizontal: "right" }}
//                 PaperProps={{ sx: { mt: 1, p: 1, width: 290 } }}
//               >
//                 <List disablePadding>
//                   {access.system_role_name === "Admin" && (
//                     <MenuItem
//                       onClick={() => {
//                         navigate("/my-profile");
//                       }}
//                     >
//                       Profile
//                     </MenuItem>
//                   )}
//                   <ExpandTopBarDropOption
//                     handleCloseUserMenu={handleCloseUserMenu}
//                     name={"Settings"}
//                     list={[
//                       {
//                         name: "Change Password",
//                         url: "/settings/change-password",
//                       },
//                       access === "Admin" && {
//                         name: "Update Credentials",
//                         url: "/settings/update-credentials",
//                       },
//                     ]}
//                   />
//                   <MenuItem
//                     onClick={() => {
//                       handleLogout();
//                     }}
//                   >
//                     Logout
//                   </MenuItem>
//                 </List>
//               </Popover>
//             </Box>

//             {/* <IconButton color="inherit" onClick={handleOpenTuneMenu}>
//               <TuneIcon />
//             </IconButton>
//             <Menu
//               anchorEl={anchorElTune}
//               open={Boolean(anchorElTune)}
//               onClose={handleCloseTuneMenu}
//               anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//               transformOrigin={{ vertical: "top", horizontal: "right" }}
//               PaperProps={{ sx: { mt: 1, width: 220 } }}
//             >
//               <MenuItem onClick={() => handleSelectOption("PROJECTIFY")}>
//                 PROJECTIFY
//               </MenuItem>
//               <MenuItem
//                 onClick={() => handleSelectOption("Project Management")}
//               >
//                 Project Management
//               </MenuItem>
//             </Menu> */}
//           </Toolbar>
//         </AppBar>

//         {showSidebar && sidebarVisible && (
//           <Drawer
//             variant="permanent"
//             sx={{
//               height: "100vh",
//               width: collapsed ? 75 : drawerWidth,
//               flexShrink: 0,
//               whiteSpace: "nowrap",
//               transition: "width 0.3s",
//               [`& .MuiDrawer-paper`]: {
//                 width: collapsed ? 75 : drawerWidth,
//                 transition: "width 0.3s",
//                 overflowX: "hidden",
//                 overflowY: "auto",
//                 boxSizing: "border-box",
//                 position: "relative",
//                 height: "100vh",
//               },
//             }}
//           >
//             <Toolbar />
//             <Box sx={{ pt: 2 }}>
//               <List>
//                 {sidebarOptions?.map((item, index) => {
//                   if (item.kind === "divider")
//                     return <Divider key={index} sx={{ my: 1 }} />;
//                   if (item.kind === "header")
//                     return (
//                       !collapsed && (
//                         <Typography
//                           key={index}
//                           variant="subtitle2"
//                           sx={{
//                             pl: 2,
//                             pt: 1.5,
//                             pb: 0.5,
//                             color: "text.secondary",
//                           }}
//                         >
//                           {item.title}
//                         </Typography>
//                       )
//                     );
//                   if (item.children) {
//                     return (
//                       <ExpandedSideOption
//                         collapsed={collapsed}
//                         item={item}
//                         key={index}
//                       />
//                     );
//                   }
//                   return (
//                     <ListItem
//                       button
//                       key={item.heading}
//                       onClick={() =>
//                         item.title === "Logout"
//                           ? handleLogout()
//                           : navigate(item.route)
//                       }
//                       sx={{ py: 1, minWidth: "40px", cursor: "pointer" }}
//                     >
//                       {item.icon && (
//                         <ListItemIcon
//                           sx={{ minWidth: "35px", cursor: "pointer" }}
//                         >
//                           {item.icon}
//                         </ListItemIcon>
//                       )}
//                       {!collapsed && (
//                         <ListItemText
//                           primary={item.title}
//                           sx={{ cursor: "pointer" }}
//                         />
//                       )}
//                     </ListItem>
//                   );
//                 })}
//               </List>
//             </Box>

//             {!collapsed && (
//               <Box
//                 onMouseDown={() => setIsResizing(true)}
//                 sx={{
//                   position: "absolute",
//                   top: 0,
//                   right: 0,
//                   width: "5px",
//                   height: "100%",
//                   cursor: "col-resize",
//                   zIndex: 999,
//                 }}
//               />
//             )}
//           </Drawer>
//         )}
//         <Box
//           component="main"
//           sx={{
//             flexGrow: 1,
//             bgcolor: "background.default",
//             transition: "margin-left 0.3s",
//             overflowY: "auto", // Enable vertical scroll for right side
//             height: "100vh",
//           }}
//         >
//           <Toolbar />
//           {children}
//           {/* <Footer /> */}
//         </Box>
//       </Box>
//     </ThemeProvider>
//   );
// }




"use client";
import React, { useEffect, useMemo, useRef, useState } from "react";
import "./IndexPageLayout.css";
import useAuthStore from "../../Zustand/Store/useAuthStore";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  CssBaseline,
  createTheme,
  ThemeProvider,
  useMediaQuery,
} from "@mui/material";

import {
  Menu as MenuIcon,
  Lock as LockIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import { ChevronsUpDown, Bell, Settings as SettingsLucide, Search, Moon, Sun } from "lucide-react";

import Swal from "sweetalert2";
import axios from "axios";
import { MAIN_URL, getApiHeaders } from "../../Configurations/Urls";
import useEmployeeDataStore from "../../Zustand/Store/useEmployeeDataStore";
import { routes } from "../../Configurations/PermissionConfigrations";
import NotAllowed from "../../Exceptions/NotAllowed";
import usePermissionDataStore from "../../Zustand/Store/usePermissionDataStore";
import SideBar from "../../Assets/Static/SideBar";
import {
  applyPreferredOrganizationToUserPayload,
  clearClientPreferredOrganizationId,
  setClientPreferredOrganizationId,
} from "../../Utils/clientActiveOrganization";
import {
  canViewOrganizationPage,
  hasPermissionAction,
} from "../../Utils/organizationPermissions";

let lastCompletedPermissionOrgUserId = null;

export default function RouteProtector({ children }) {
  const [darkMode, setDarkMode] = useState(() => {
    try {
      return localStorage.getItem("ems_dark_mode") === "true";
    } catch {
      return false;
    }
  });
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem("ems-collapsed") === "1";
    } catch {
      return false;
    }
  });
  const [drawerWidth, setDrawerWidth] = useState(310);
  const [isResizing, setIsResizing] = useState(false);
  const { resetData } = useEmployeeDataStore();
  const { Permission, isPermissionLoaded, setPermission } =
    usePermissionDataStore();

  const isMobile = useMediaQuery("(max-width:768px)");
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem("ems_dark_mode", String(darkMode));
    } catch {
      // Ignore storage failures (private mode / blocked storage).
    }
    document.documentElement.setAttribute("data-theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode: darkMode ? "dark" : "light",
          background: {
            // Keep MUI surfaces aligned with EMS CSS tokens (see `src/ems-design.css`)
            default: "var(--ems-bg)",
            paper: "var(--ems-surface)",
          },
        },
        components: {
          MuiTextField: {
            defaultProps: {
              variant: "outlined",
            },
          },
          MuiFormControl: {
            defaultProps: {
              variant: "outlined",
            },
          },
        },
      }),
    [darkMode]
  );

  const navigate = useNavigate();
  const location = useLocation();

  const [activeMenu, setActiveMenu] = useState(null); // 'user' | 'notif' | 'org' | null
  const [orgQuery, setOrgQuery] = useState("");
  const [allClientOrgs, setAllClientOrgs] = useState([]);
  const [orgListLoading, setOrgListLoading] = useState(false);
  const [orgSwitching, setOrgSwitching] = useState(null); // org_id being switched to
  const menuContainerRef = useRef(null);

  const toggleMenu = (m) => {
    setActiveMenu((cur) => {
      const next = cur === m ? null : m;
      if (next === "org") {
        const clientId = userData?.organization?.client_id;
        if (clientId) {
          setOrgListLoading(true);
          axios.get(`${MAIN_URL}/api/organizations/v1`, {
            params: { client_id: clientId },
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          })
            .then((res) => setAllClientOrgs(res.data?.organizations?.data || []))
            .catch(() => {})
            .finally(() => setOrgListLoading(false));
        }
        setOrgQuery("");
      }
      return next;
    });
  };
  const closeMenu = () => setActiveMenu(null);

  const switchOrg = async (orgId) => {
    if (orgSwitching) return;
    setOrgSwitching(orgId);
    try {
      const response = await axios.post(
        `${MAIN_URL}/api/organizations/extra/active`,
        { organization_id: orgId, application_user_id: userData?.application_user_id },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      const { user } = response.data;
      const allOrgs = Array.isArray(user?.organization) ? user.organization : allClientOrgs;
      const activeOrg = allOrgs.find((o) => Number(o.organization_id) === Number(orgId)) || allClientOrgs.find((o) => Number(o.organization_id) === Number(orgId)) || null;
      setClientPreferredOrganizationId(orgId);
      login({ ...user, organizations: allOrgs, organization: activeOrg });
      closeMenu();
      navigate("/");
    } catch (e) {
      console.error("Org switch failed", e);
    } finally {
      setOrgSwitching(null);
    }
  };

  useEffect(() => {
    if (!activeMenu) return;
    const onDown = (e) => {
      if (menuContainerRef.current && !menuContainerRef.current.contains(e.target)) {
        setActiveMenu(null);
      }
    };
    const onKey = (e) => { if (e.key === "Escape") setActiveMenu(null); };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [activeMenu]);

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setCollapsed((c) => {
        const next = !c;
        try {
          localStorage.setItem("ems-collapsed", next ? "1" : "0");
        } catch {
          // Ignore storage failures.
        }
        return next;
      });
    }
  };

  useEffect(() => {
    if (isMobile) {
      setMobileOpen(false);
    }
  }, [location.pathname, isMobile]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isResizing && !isMobile) {
        const newWidth = Math.min(Math.max(e.clientX, 100), 500);
        setDrawerWidth(newWidth);
      }
    };

    const handleMouseUp = () => {
      if (isResizing) setIsResizing(false);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isResizing, isMobile]);

  const { logout, userData, setAccess, login } = useAuthStore();

  const clearSessionAndGoToLogin = React.useCallback(() => {
    logout();
    localStorage.removeItem("token");
    clearClientPreferredOrganizationId();
    lastCompletedPermissionOrgUserId = null;
    navigate("/login", { replace: true });
  }, [logout, navigate]);

  const roleLabel =
    typeof userData?.role === "string"
      ? userData.role
      : userData?.role?.system_role_name ||
        userData?.role?.role?.system_role_name ||
        "User";

  const access = roleLabel || "Admin";
  const [loadPermission, setLoadPermission] = useState(true);
  const activeOrganizationId =
    userData?.user_active_organization?.organization_id ||
    userData?.organization?.organization_id;
  const activeOrganizationUserId =
    userData?.organizationuser?.organization_user_id ||
    userData?.metadata?.find(
      (item) => Number(item?.organization_id) === Number(activeOrganizationId)
    )?.organization_user_id;

  const normalizedOrgUserId = useMemo(() => {
    if (
      activeOrganizationUserId == null ||
      activeOrganizationUserId === ""
    ) {
      return null;
    }
    const n = Number(activeOrganizationUserId);
    return Number.isFinite(n) ? n : null;
  }, [activeOrganizationUserId]);

  console.log("permission is ", Permission);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const token = localStorage.getItem("token");

          await axios.get(`${MAIN_URL}/api/auth/logout`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          logout();
          clearClientPreferredOrganizationId();
          lastCompletedPermissionOrgUserId = null;
          localStorage.removeItem("token");

          Swal.fire("Logged out!", "You have been logged out.", "success");
          navigate("/login");
        } catch (error) {
          console.error("Logout failed:", error);
          Swal.fire("Error", "Logout failed. Please try again.", "error");
        }
      }
    });
  };

  const { isLoggedIn } = useAuthStore();
  const [OpenTCode, setOpenTCode] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "/") {
        setOpenTCode(true);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const [isAllowed, setisAllowed] = useState(true);

  useEffect(() => {
    const currentPath = location.pathname;
    localStorage.setItem("lastVisitedRoute", currentPath);

    if (currentPath && Permission?.length > 0) {
      // alert("gugug")

      const basePath = currentPath.includes("/edit")
        ? `${currentPath.split("/edit")[0]}/edit`
        : currentPath;

      const matchedRoute = routes.find((item) => item.name === basePath);
      console.log("match", matchedRoute);
      const hasRoutePermission = (action) => hasPermissionAction(Permission, action);

      if (!matchedRoute) {
        //   alert("hjhhd")
        setisAllowed(true);
      } else if (matchedRoute.action && hasRoutePermission(matchedRoute.action)) {
        // alert("jghughugd")

        console.log("basePath ", basePath);
        console.log("matchedRoute ", matchedRoute);

        setisAllowed(true);
      } else {
        //   alert("abcdre")
        setisAllowed(false);
      }
      console.log("Matched route is", matchedRoute);
    }
  }, [location, Permission]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      clearSessionAndGoToLogin();
      return;
    }

    const storeUser = useAuthStore.getState().userData;
    const alreadyHydrated =
      storeUser &&
      (storeUser.organizationuser?.organization_user_id ||
        (Array.isArray(storeUser.metadata) && storeUser.metadata.length > 0));

    if (alreadyHydrated) {
      return;
    }

    axios
      .get(`${MAIN_URL}/api/auth/token-login`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        let { user } = response.data;

        const allOrgs = Array.isArray(user?.organization) ? user.organization : [];

        user = applyPreferredOrganizationToUserPayload(user);

        setAccess(user?.role?.system_role_name);

        const activeOrgId =
          user?.user_active_organization?.organization_id ||
          user?.user_active_organization?.user_current_active_organization_id ||
          user?.activeOrganization?.user_current_active_organization_id ||
          user?.activeOrganization?.organization_id;

        const dd = allOrgs.find(
          (item) => Number(item.organization_id) === Number(activeOrgId)
        );

        const mergedOrgUser =
          user?.organizationuser ||
          user?.metadata?.find(
            (item) => Number(item?.organization_id) === Number(activeOrgId)
          );

        const mm = {
          ...user,
          organizations: allOrgs,
          organization: dd ?? allOrgs[0] ?? null,
          organizationuser: mergedOrgUser ?? user.organizationuser,
        };
        login(mm);
      })
      .catch(() => {
        clearSessionAndGoToLogin();
      });
  }, [clearSessionAndGoToLogin, login, setAccess]);

  useEffect(() => {
    const currentPath = location.pathname;
    if (
      currentPath === "/organization/employee/employee-details/add" ||
      currentPath === "/organization/employee/employee-details"
    ) {
      resetData();
    }
  }, [location.pathname]);

  useEffect(() => {
    const currentPath = location.pathname;
    if (
      currentPath === "/organization/intern/intern-details/add" ||
      currentPath === "/organization/intern/intern-details"
    ) {
      resetData();
    }
  }, [location.pathname]);

  // useEffect(() => {
  //   const checkPermission = async () => {
  //     setLoadPermission(true);

  //     try {
  //       const res = await axios.get(
  //         `${MAIN_URL}/api/user/${userData?.metadata?.[0]?.organization_user_id}/has-access`
  //       );

  //       const allowed = res?.data?.allowed_actions || [];
  //       setPermission(allowed);

  //       // Redirect immediately if no permission
  //       if (allowed.length === 0) {
  //         return navigate("/not-authorised");
  //       }
  //     } catch (error) {
  //       console.error("Permission check error:", error);
  //     } finally {
  //       setLoadPermission(false);
  //     }
  //   };

  //   if (userData?.metadata?.[0]?.organization_user_id) {
  //     checkPermission();
  //   }
  // }, [userData?.metadata?.[0]?.organization_user_id]);


  useEffect(() => {
    const token = localStorage.getItem("token");
    const storeUser = useAuthStore.getState().userData;

    if (!normalizedOrgUserId) {
      lastCompletedPermissionOrgUserId = null;
      setPermission([]);
      if (!token) {
        setLoadPermission(false);
      } else if (!storeUser) {
        setLoadPermission(true);
      } else {
        setLoadPermission(false);
      }
      return;
    }

    const existing = usePermissionDataStore.getState().Permission;
    if (
      lastCompletedPermissionOrgUserId === normalizedOrgUserId &&
      Array.isArray(existing) &&
      existing.length > 0
    ) {
      setLoadPermission(false);
      return;
    }

    const ac = new AbortController();
    let cancelled = false;

    const run = async () => {
      setLoadPermission(true);
      try {
        const res = await axios.get(
          `${MAIN_URL}/api/user/${normalizedOrgUserId}/check-permission-access`,
          {
            signal: ac.signal,
            headers: getApiHeaders(),
          }
        );
        if (cancelled) return;

        const allowed = res?.data?.allowed_actions || [];
        setPermission(allowed);

        if (allowed.length === 0) {
          lastCompletedPermissionOrgUserId = null;
          navigate("/not-authorised", { replace: true });
          return;
        }
        lastCompletedPermissionOrgUserId = normalizedOrgUserId;
      } catch (error) {
        if (cancelled || error?.code === "ERR_CANCELED") return;
        console.error("Permission check error:", error);
        if (error.response?.status === 404) {
          navigate("/not-authorised", { replace: true });
        }
      } finally {
        if (!cancelled) {
          setLoadPermission(false);
        }
      }
    };

    run();

    return () => {
      cancelled = true;
      ac.abort();
    };
  }, [normalizedOrgUserId, navigate, setPermission]);

  

  // 🚫 Block component rendering until permission check finishes
  if (loadPermission) {
    return (
      <div className="ems-perm-loading">
        <div className="ems-perm-card">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none"
            style={{ animation: "spin 0.9s linear infinite" }}>
            <circle cx="18" cy="18" r="15" stroke="var(--ems-border-strong)"
              strokeWidth="3" fill="none" />
            <path d="M18 3 A15 15 0 0 1 33 18" stroke="var(--ems-primary)"
              strokeWidth="3" strokeLinecap="round" fill="none" />
          </svg>
          <p className="ems-perm-title">Checking Permissions…</p>
          <p className="ems-perm-sub">Setting up your workspace</p>
        </div>
      </div>
    );
  }

  // 🔐 Route-based Access Control

  const currentPath = location.pathname;
  //console.log("current path is sikjs", currentPath);

  // Protect Employees Page from Admins
  if (access === "Admin" && currentPath === "/sidebar-option-page-1") {
    return <Navigate to="/" replace />;
  }

  // Protect Admin-only page from Users
  if (!isAllowed) {
    return <NotAllowed />;
  }


  console.log("axcess", access);
  console.log("userdata", userData);

  const canNavigateToOrganizationPage = canViewOrganizationPage(Permission);

  const handleOrganizationNameClick = () => {
    if (canNavigateToOrganizationPage) {
      navigate("/organization/switcher");
    }
  };

  const renderSidebarContent = () => (
    <SideBar Permission={Permission} collapsed={collapsed} />
  );

  const userInitials = (() => {
    const name = String(userData?.full_name || "U").trim();
    const parts = name.split(/\s+/);
    return parts.map((p) => p[0] || "").join("").toUpperCase().slice(0, 2) || "U";
  })();

  const activeOrgId = userData?.organization?.organization_id;
  const filteredOrgs = allClientOrgs.filter((o) =>
    !orgQuery || (o.organization_name || "").toLowerCase().includes(orgQuery.toLowerCase())
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="ems-shell" ref={menuContainerRef}>
        {/* ── Topbar ── */}
        <header className="ems-topbar">
          <div className="ems-topbar-lead">
            <button className="ems-icon-btn" onClick={handleDrawerToggle} aria-label="Toggle sidebar">
              <MenuIcon style={{ fontSize: 21 }} />
            </button>
            <div className="ems-brand" onClick={() => navigate("/")}>
              <div className="ems-brand-mark">EMS</div>
              {!isMobile && <span className="ems-brand-name">EMS</span>}
            </div>
          </div>

          {/* Org switcher */}
          <div className="ems-tb-anchor">
            <button
              className={`ems-company-chip${activeMenu === "org" ? " on" : ""}`}
              onClick={() => { toggleMenu("org"); setOrgQuery(""); }}
            >
              <span className="ems-company-name">
                {userData?.organization?.organization_name || "EMS"}
              </span>
              <ChevronsUpDown size={16} />
            </button>
            {activeMenu === "org" && (
              <div className="ems-tb-pop ems-tb-pop-org">
                <div className="ems-tb-pop-head">
                  <span className="ems-tb-pop-title">Switch organization</span>
                </div>
                <div className="ems-tb-org-search">
                  <Search size={16} />
                  <input
                    placeholder="Search organizations…"
                    value={orgQuery}
                    onChange={(e) => setOrgQuery(e.target.value)}
                    autoFocus
                  />
                </div>
                <div className="ems-tb-org-list">
                  {orgListLoading ? (
                    <div className="ems-tb-empty">Loading…</div>
                  ) : filteredOrgs.length === 0 ? (
                    <div className="ems-tb-empty">No organizations found.</div>
                  ) : filteredOrgs.map((o) => {
                    const isActive = String(o.organization_id) === String(activeOrgId);
                    const isSwitching = orgSwitching === o.organization_id;
                    const name = o.organization_name || "Organization";
                    const short = name.split(" ").map((w) => w[0] || "").join("").toUpperCase().slice(0, 2);
                    return (
                      <button
                        key={o.organization_id}
                        className={`ems-tb-org${isActive ? " active" : ""}`}
                        disabled={!!orgSwitching}
                        onClick={() => { if (!isActive) switchOrg(o.organization_id); }}
                      >
                        <span className="ems-tb-org-logo">{short}</span>
                        <span className="ems-tb-org-meta">
                          <span className="ems-tb-org-name">{name}</span>
                          {o.organization_short_name && (
                            <span className="ems-tb-org-short">{o.organization_short_name}</span>
                          )}
                        </span>
                        {isSwitching
                          ? <span className="ems-tb-org-status">Switching…</span>
                          : isActive
                            ? <span className="ems-tb-org-status active"><span className="ems-tb-org-dot" />Active</span>
                            : <span className="ems-tb-org-status">Inactive</span>}
                      </button>
                    );
                  })}
                </div>
                <div className="ems-tb-pop-foot">
                  <button className="ems-tb-foot-btn" onClick={() => { closeMenu(); navigate("/organization/switcher"); }}>
                    Manage organizations
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="ems-topbar-spacer" />

          <div className="ems-topbar-tools">
            {/* Dark mode toggle */}
            <button className="ems-icon-btn" onClick={() => setDarkMode(!darkMode)} title={darkMode ? "Light mode" : "Dark mode"}>
              {darkMode ? <Sun size={19} /> : <Moon size={19} />}
            </button>

            {/* Notifications */}
            <div className="ems-tb-anchor">
              <button
                className={`ems-icon-btn ems-notif-btn${activeMenu === "notif" ? " on" : ""}`}
                onClick={() => toggleMenu("notif")}
                aria-label="Notifications"
              >
                <Bell size={19} />
                <span className="ems-notif-dot" />
              </button>
              {activeMenu === "notif" && (
                <div className="ems-tb-pop ems-tb-pop-notif">
                  <div className="ems-tb-pop-head">
                    <span className="ems-tb-pop-title">
                      Notifications
                    </span>
                    <button className="ems-tb-link" disabled>Mark all read</button>
                  </div>
                  <div className="ems-tb-empty">No notifications yet.</div>
                </div>
              )}
            </div>

            {/* Settings */}
            <button className="ems-icon-btn" title="Settings" onClick={() => { closeMenu(); navigate("/settings/change-password"); }}>
              <SettingsLucide size={19} />
            </button>

            {/* User menu */}
            <div className="ems-tb-anchor">
              <button
                className={`ems-user-chip${activeMenu === "user" ? " on" : ""}`}
                onClick={() => toggleMenu("user")}
                aria-label="User menu"
              >
                <span className="ems-user-name">{userData?.full_name || "User"}</span>
                <div className="ems-avatar">{userInitials}</div>
              </button>
              {activeMenu === "user" && (
                <div className="ems-tb-pop ems-tb-pop-menu" style={{ minWidth: 260 }}>
                  <div className="ems-tb-user-head">
                    <div className="ems-avatar" style={{ width: 44, height: 44, fontSize: 15 }}>{userInitials}</div>
                    <div className="ems-tb-user-meta">
                      <span className="ems-tb-user-name">{userData?.full_name || "User"}</span>
                      <span className="ems-tb-user-mail">{userData?.email || ""}</span>
                      <span className="ems-tb-user-role">{roleLabel}</span>
                    </div>
                  </div>
                  <div className="ems-tb-divider" />
                  {Permission && Permission.includes("USER_RESET_PASSWORD") && (
                    <button className="ems-tb-item" onClick={() => { closeMenu(); navigate("/settings/change-password"); }}>
                      <LockIcon style={{ fontSize: 17 }} />
                      Change Password
                    </button>
                  )}
                  <div className="ems-tb-divider" />
                  <button className="ems-tb-item danger" onClick={() => { closeMenu(); handleLogout(); }}>
                    <LogoutIcon style={{ fontSize: 17 }} />
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* ── Body ── */}
        <div className="ems-body">
          {isMobile && mobileOpen && (
            <div className="ems-sidebar-overlay" onClick={() => setMobileOpen(false)} />
          )}
          <aside className={["ems-sidebar", collapsed && !isMobile ? "ems-collapsed" : "", isMobile && mobileOpen ? "mobile-open" : ""].filter(Boolean).join(" ")}>
            {renderSidebarContent()}
          </aside>
          <main className="ems-content">
            <div className="ems-content-inner">{children}</div>
          </main>
        </div>
      </div>
    </ThemeProvider>
  );

}
